import MasterIcon from '@/assets/icons/credit-card/master.svg';
import VisaIcon from '@/assets/icons/credit-card/visa.svg';
import AmexIcon from '@/assets/icons/credit-card/amex.svg';
import DiscoverIcon from '@/assets/icons/credit-card/discover.svg';

import MasterIconR from '@/assets/icons/credit-card/rounded/master.svg';
import VisaIconR from '@/assets/icons/credit-card/rounded/visa.svg';
import AmexIconR from '@/assets/icons/credit-card/rounded/amex.svg';
import DiscoverIconR from '@/assets/icons/credit-card/rounded/discover.svg';

import { CardType } from '../endpoints/customers';
import { LoadScriptProps } from '@react-google-maps/api';

export const mainAddress = '23041 Avenida De La Carlota, Suite 310 Laguna Hills, CA 92653';

export const creditCardIcons: { [key in CardType]: string } = {
    mastercard: MasterIcon,
    visa: VisaIcon,
    'american-express': AmexIcon,
    discover: DiscoverIcon
};

export const creditCardRoundedIcons: { [key in CardType]: string } = {
    mastercard: MasterIconR,
    visa: VisaIconR,
    'american-express': AmexIconR,
    discover: DiscoverIconR
};

export const consolidatedRouteLibraries: LoadScriptProps['libraries'] = ['places', 'maps', 'marker', 'geocoding', 'geometry'];

export const localPharmacyNPIs = ['1114387990', '1336170679'];